/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const billingProfileDataPreferredPaymentMethodSchema = z.enum(['stripe', 'invoice'])

export type BillingProfileDataPreferredPaymentMethodSchema = z.infer<
	typeof billingProfileDataPreferredPaymentMethodSchema
>
